import { PropsWithChildren, useEffect } from 'react';
import { DndProvider as ReactDndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';

import { useIsGlobalDragging } from 'shared/utils/useIsGlobalDragging';

import { DndAllowedItemsContextProvider } from '../DndAllowedItemsContextProvider';

const PreventUserSelectOnDrag = ({ children }: PropsWithChildren) => {
  const isDragging = useIsGlobalDragging();
  useEffect(() => {
    if (isDragging) {
      document.body.classList.add('dragging');
    } else {
      document.body.classList.remove('dragging');
    }

    return () => {
      document.body.classList.remove('dragging');
    };
  }, [isDragging]);
  return children;
};

export function DndProvider({ children }: PropsWithChildren) {
  return (
    <ReactDndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
      <DndAllowedItemsContextProvider>
        <PreventUserSelectOnDrag>{children}</PreventUserSelectOnDrag>
      </DndAllowedItemsContextProvider>
    </ReactDndProvider>
  );
}
